<h1 mat-dialog-title>{{title}}
  <sfc-icon name="rds-icon-times" size="xs" class="clickable" (click)="close()">
  </sfc-icon>
</h1>
<div mat-dialog-content>
  <div *ngIf='hasData ; else errorTextField'>
    <div class="details-name-value-pairs">
      <div class="details-name-value-pair wide">
        <label class="details-name wide">Arrangement: {{arrangement}}</label>
      </div>
    </div>
    <ng-container #table></ng-container>
  </div>
</div>

<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
